import { useMemo } from 'react';

import filter, { components } from '@Components/Grid/utils/filter';
import { useGlobalAuthStore } from '@Stores/global/auth';

import TagsFilter from './TagsFilter';

export default function useFilters() {
  const { auth: { isSuperAdmin, isManagerAdmin } } = useGlobalAuthStore()
  const isAdmin = isSuperAdmin || isManagerAdmin

  return useMemo(() => [
    filter
      .options.list('source', 'Source', [...SETTINGS_SOURCE_OPTIONS, ...isAdmin ? ADMIN_SOURCE_OPTIONS : []])
      .multi(true),
    filter
      .options.list('level', 'Level', LEVEL_OPTIONS)
      .multi(true),
    filter('tags', 'Tags').component(TagsFilter),
    filter('date', 'Date').component(components.date),
  ], [isAdmin])
}

const SETTINGS_SOURCE_OPTIONS = [
  { label: 'Ping check', value: 'preping' },
  { label: 'Conversion Pixel', value: 'conversion-pixel' },
  { label: 'Registration Call', value: 'lmain' },
]

const ADMIN_SOURCE_OPTIONS = [
  { label: 'Path Ping Post', value: 'path-ping-post' },
  { label: 'Ping check', value: 'preping' },
  { label: 'Conversion Pixel', value: 'conversion-pixel' },
  { label: 'Registration Call', value: 'lmain' },
  { label: 'Postback', value: 'postback' },
  { label: 'Registration Status', value: 'registration-status' },
  { label: 'Path Calls', value: 'path-call' },
  { label: 'Page Calls', value: 'page-call' },
  { label: 'Pixel Calls', value: 'pixel-call' },
  { label: 'User Profile', value: 'user-profile' },
  { label: 'TCPA Call to Twyne', value: 'tcpa-preping' },
  { label: 'TCPA Page Answer', value: 'tcpa-answer' },
  { label: 'Unsubscribe', value: 'unsubscribe' },
  { label: 'Blacklist Block', value: 'blacklist-block' },
  { label: 'Wildcard Redirect', value: 'wildcard-redirect' },
  { label: 'Verification Throttle', value: 'verification-throttle' },
  { label: 'Rewards', value: 'rewards' },
  { label: 'Recaptcha Error', value: 'recaptcha-error' },
  { label: 'Anura Error', value: 'anura-error' },
  { label: 'Path Preflight', value: 'path-preflight' },
  { label: 'Custom Conversion', value: 'custom-conversion' },
]

const LEVEL_OPTIONS = [
  { label: 'Info', value: 'info' },
  { label: 'Warn', value: 'warn' },
  { label: 'Error', value: 'error' },
]
